/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import ReducerIndex from 'qwc2/reducers/index';
import hybridReducer from '../reducers/hybrid';
import MapUtils from "../../qwc2/utils/MapUtils";
import {configureMap} from "../../qwc2/actions/map";
import {addLayer, LayerRole} from "../../qwc2/actions/layers";
import ThemeUtils from "../../qwc2/utils/ThemeUtils";
ReducerIndex.register("hybrid", hybridReducer);

export const REPOSITORIES_LOADED = 'REPOSITORIES_LOADED';
export const SET_REPOSITORIES = 'SET_REPOSITORIES';

export function setRepositories(repositories) {
    return (dispatch, getState) => {
        // Reconfigure map
        /*dispatch(configureMap(repositories.mapCrs, repositories.scales, repositories.initialBbox));

        const curBgLayer = getState().layers.flat.find(layer => layer.role === LayerRole.BACKGROUND && layer.visibility === true);
        let visibleBgLayer = curBgLayer ? curBgLayer.name : null;

        for (const bgLayer of ThemeUtils.createThemeBackgroundLayers(theme, themes, visibleBgLayer)) {
            dispatch(addLayer(bgLayer));
        }*/

        // set repos
        dispatch({
            type: SET_REPOSITORIES,
            repositories: repositories
        });
    };
}

export function repositoriesLoaded(repositories) {
    return {
        type: REPOSITORIES_LOADED,
        repositories
    };
}
